/* Osmanlı Doğal Taş — Rüya Tabiri · kişisel harman katmanı
   ------------------------------------------------------------------
   Sembol sözlüğü tek başına "genel" bir okuma verir. Derinlik, rüyayı
   RÜYAYI GÖRENLE birleştirmekten çıkar: doğum tarihinden burç, element,
   yaşam yolu ve kişisel yıl hesaplanır; rüyanın sembolleriyle çakışan
   ya da çelişen yerler ayrıca okunur.
   Hesaplar mağazadaki diğer modüllerle aynı yöntemi kullanır
   (numeroloji: Pisagor indirgemesi; burç: tarih aralığı). */
(function (g) {
  "use strict";

  var BURC = [
    ["Oğlak", 1, 1, 1, 19, "toprak"], ["Kova", 1, 20, 2, 18, "hava"], ["Balık", 2, 19, 3, 20, "su"],
    ["Koç", 3, 21, 4, 19, "ates"], ["Boğa", 4, 20, 5, 20, "toprak"], ["İkizler", 5, 21, 6, 21, "hava"],
    ["Yengeç", 6, 22, 7, 22, "su"], ["Aslan", 7, 23, 8, 22, "ates"], ["Başak", 8, 23, 9, 22, "toprak"],
    ["Terazi", 9, 23, 10, 22, "hava"], ["Akrep", 10, 23, 11, 21, "su"], ["Yay", 11, 22, 12, 21, "ates"],
    ["Oğlak", 12, 22, 12, 31, "toprak"]
  ];
  function burc(g_, a) {
    for (var i = 0; i < BURC.length; i++) {
      var b = BURC[i];
      if ((a === b[1] && g_ >= b[2]) || (a === b[3] && g_ <= b[4])) return { ad: b[0], element: b[5] };
    }
    return { ad: "Oğlak", element: "toprak" };
  }

  var ELEMENT = {
    ates:   { ad: "Ateş",   huy: "hareket, cesaret ve çabuk tutuşan bir iç" },
    toprak: { ad: "Toprak", huy: "sabır, somutluk ve yavaş ama sağlam ilerleyiş" },
    hava:   { ad: "Hava",   huy: "zihin, merak ve sürekli dolaşan bir düşünce" },
    su:     { ad: "Su",     huy: "sezgi, derinlik ve hissederek anlama" }
  };

  /* Sembollerin element karşılıkları — rüya ile tabiatın çakışmasını okumak için */
  var SEMBOL_ELEMENT = {
    "Su": "su", "Deniz": "su", "Akarsu": "su", "Yağmur": "su", "Kar": "su", "Balık": "su",
    "Ağlamak": "su", "Yüzmek": "su", "Kuyu": "su", "Süt": "su", "Gözyaşı": "su",
    "Ateş": "ates", "Güneş": "ates", "Aslan": "ates", "Şimşek": "ates", "At": "ates", "Kartal": "ates",
    "Toprak": "toprak", "Dağ": "toprak", "Ağaç": "toprak", "Ev": "toprak", "Ekmek": "toprak",
    "Meyve": "toprak", "İnek": "toprak", "Karınca": "toprak", "Altın": "toprak",
    "Rüzgâr": "hava", "Uçmak": "hava", "Kuş": "hava", "Gökyüzü": "hava", "Bulut": "hava",
    "Güvercin": "hava", "Kelebek": "hava", "Yıldız": "hava"
  };

  function indirge(n, ustaKoru) {
    while (n > 9) {
      if (ustaKoru && (n === 11 || n === 22 || n === 33)) return n;
      n = String(n).split("").reduce(function (a, b) { return a + (+b); }, 0);
    }
    return n;
  }
  function yasamYolu(gun, ay, yil) {
    return indirge(indirge(gun, false) + indirge(ay, false) + indirge(yil, false), true);
  }
  function kisiselYil(gun, ay) {
    var y = new Date().getFullYear();
    var d = new Date();
    /* doğum günü henüz gelmediyse bir önceki kişisel yıl geçerlidir */
    if (d.getMonth() + 1 < ay || (d.getMonth() + 1 === ay && d.getDate() < gun)) y -= 1;
    return indirge(indirge(gun, false) + indirge(ay, false) + indirge(y, false), false);
  }

  var YOL_METIN = {
    1: "kendi yolunu kurma", 2: "birlikte yürüme ve denge", 3: "ifade ve üretme",
    4: "sağlam temel kurma", 5: "değişim ve özgürlük", 6: "sorumluluk ve gönül işleri",
    7: "araştırma ve içe bakış", 8: "kudret ve karşılık", 9: "tamamlama ve bırakma",
    11: "sezgi ve ilham", 22: "büyük bir işi kurma", 33: "şefkatle öğretme"
  };
  var YIL_METIN = {
    1: "yeni bir şeyin başladığı", 2: "sabır ve bekleme isteyen", 3: "açılma ve görünür olma",
    4: "emek ve düzen kurma", 5: "hareket ve değişim", 6: "yakınlar ve sorumluluk",
    7: "içe dönme ve anlama", 8: "karşılık alma", 9: "kapanış ve arınma"
  };

  g.ODTRuyaHarman = {
    hesapla: function (gun, ay, yil) {
      var b = burc(gun, ay);
      return {
        burc: b.ad, element: b.element, elementAd: ELEMENT[b.element].ad, elementHuy: ELEMENT[b.element].huy,
        yol: yasamYolu(gun, ay, yil), yolMetin: YOL_METIN[yasamYolu(gun, ay, yil)] || "kendi yolunu bulma",
        yil: kisiselYil(gun, ay), yilMetin: YIL_METIN[kisiselYil(gun, ay)] || "geçiş"
      };
    },

    /* Rüyanın sembolleri ile kişinin tabiatı arasındaki ilişki */
    ortusme: function (semboller, element) {
      var ayni = [], zit = [];
      var karsit = { ates: "su", su: "ates", hava: "toprak", toprak: "hava" };
      semboller.forEach(function (s) {
        var e = SEMBOL_ELEMENT[s.ad];
        if (!e) return;
        if (e === element) ayni.push(s.ad);
        else if (e === karsit[element]) zit.push(s.ad);
      });
      return { ayni: ayni, zit: zit };
    },

    /* Derin okuma paragrafları — kişiye ve rüyaya birlikte bakar */
    derin: function (ad, h, r) {
      var p = [], o = this.ortusme(r.semboller, h.element);
      var mihver = r.semboller.length ? r.semboller[0].ad.toLocaleLowerCase("tr") : "";
      var ilk = r.semboller.length ? r.semboller[0].ad.toLocaleLowerCase("tr") : "";

      p.push({
        bas: "Mizacın bu rüyaya ne söylüyor",
        yazi: (mihver ? "Rüyanın merkezindeki <strong>" + mihver + "</strong> sembolünü kendi tabiatınla birlikte okuyalım. " : "") +
          "<strong>" + ad + "</strong>, doğum tarihine göre <strong>" + h.burc + "</strong> burcundasın; " +
          "hâkim unsurun <strong>" + h.elementAd + "</strong> — yani " + h.elementHuy + ". " +
          (o.ayni.length
            ? "Rüyanda <strong>" + o.ayni.join(", ").toLocaleLowerCase("tr") + "</strong> görmen bu tabiatla aynı yönde: rüyan sana yabancı bir dilden değil, <em>kendi dilinden</em> konuşuyor. Klasik tabirde kişinin mizacıyla uyumlu semboller daha kuvvetli sayılır."
            : o.zit.length
              ? "Rüyanda <strong>" + o.zit.join(", ").toLocaleLowerCase("tr") + "</strong> görmen ise tabiatının karşı ucundan geliyor. Bu bir çelişki değil; çoğu zaman kişinin eksik bıraktığı tarafın kendini hatırlatmasıdır."
              : "Rüyandaki semboller doğrudan bir unsura bağlanmıyor; bu da rüyanın mizacından çok gündelik hâlinle ilgili olduğunu düşündürür.")
      });

      p.push({
        bas: "Yaşam yolunla bağı",
        yazi: "Sayı hesabına göre yaşam yolun <strong>" + h.yol + "</strong> — ana meselen <em>" + h.yolMetin + "</em>. " +
          (ilk ? "Rüyanın merkezindeki <strong>" + ilk + "</strong> sembolünü bu meselenin yanına koyduğunda okuma keskinleşir: " : "") +
          (r.hal === "yol" ? "rüyan da tam olarak bir yön arayışını gösteriyor, yani ikisi aynı şeyi söylüyor."
            : r.hal === "koruma" ? "rüyan korunma ihtiyacını öne çıkarıyor; yolunda ilerlerken neyi savunmaya çalıştığına bakmakta fayda var."
            : r.hal === "bolluk" ? "rüyan emeğin karşılığına işaret ediyor; yolunla kazancın aynı hizada mı, orası düşünmeye değer."
            : r.hal === "sifa" ? "rüyan bir yükten hafifleme istiyor; bu yükün yolunla ilgisi olabilir."
            : "rüyan bunun bugünkü görünümünü taşıyor.")
      });

      p.push({
        bas: "Bu rüyayı gördüğün devir",
        yazi: "Bu yıl senin için <strong>" + h.yil + " sayılı yıl</strong> — " + h.yilMetin + " bir devir. " +
          "Rüyalar çoğu zaman içinde bulunulan devrin diliyle konuşur; " +
          (h.yil === 1 || h.yil === 5 ? "yeni bir şeyin eşiğindeysen rüyanın kapı, yol ve hareket sembolleri taşıması beklenir."
            : h.yil === 9 ? "bir kapanış devrindeysen rüyanın veda, su ve arınma sembolleri taşıması olağandır."
            : h.yil === 7 ? "içe dönük bir devirdesin; rüyaların bu dönemde artması ve derinleşmesi sık görülür."
            : "gördüğün rüyayı bu devrin penceresinden okumak, ona daha yerinde bir anlam kazandırır.") +
          " Rüyanın bıraktığı his ile bu devrin hâli birbirini tutuyorsa, okuma daha da kuvvetlenir."
      });

      return p;
    }
  };
})(typeof window !== "undefined" ? window : globalThis);
